export default __webpack_public_path__ + "439b2f1d3bc9efac7803b867991cbf00.svg";